import type { Timestamp } from 'firebase/firestore';

export const formatTimestamp = (
  timestamp: Timestamp | null | undefined,
  fallback = 'Unknown Date'
): string => {
  if (!timestamp || typeof timestamp.toDate !== 'function') {
    return fallback;
  }
  return timestamp.toDate().toLocaleDateString();
};

export const formatDateFromString = (dateString: string): string => {
  if (!dateString) return '';
  const date = new Date(dateString + 'T12:00:00');
  if (isNaN(date.getTime())) return dateString; // Return raw string as fallback for invalid dates
  return date.toLocaleDateString(undefined, {
    weekday: 'long',
    month: 'long',
    day: 'numeric',
  });
};
